<form [formGroup]="emailForm">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="senderName" class="control-label required">{{ 'i18n.base.shared.email-form.form-fields.sender-name' | translate }}</label>
      <input id="senderName" type="text" class="form-control" formControlName="senderName" />
      <app-error-messages [control]="emailForm.get('senderName')"></app-error-messages>
    </div>
    <div class="form-group col-md-8">
      <label for="subject" class="control-label required">{{ 'i18n.base.shared.email-form.form-fields.subject' | translate }}</label>
      <input id="subject" type="text" class="form-control" formControlName="subject" />
      <app-error-messages [control]="emailForm.get('subject')"></app-error-messages>
    </div>
  </div>
  @if (showOutputEmailAccountField) {
    <div class="form-row row">
      <div class="form-group col-md-4">
        <label class="control-label required">{{'i18n.base.shared.email-form.form-fields.output-email-account' | translate }}</label>
        <ejs-dropdownlist id="outputEmailAccountId"
                          formControlName="emailAccountId"
                          [dataSource]="outputEmailAccounts"
                          [fields]="outputEmailAccountFields"
                          [allowFiltering]="true">
        </ejs-dropdownlist>
      </div>
    </div>
  }
  @if (showLoadFromTemplateButton) {
    <div class="form-row row">
      <div class="form-group col-md-6">
        <button type="button" class="btn btn-outline-secondary" (click)="onLoadTemplateClicked()">
          {{'i18n.base.shared.email-form.form-fields.load-from-template' | translate}}
        </button>
      </div>
    </div>
  }
  <div class="form-row row">
    <div class="form-group col-12">
      <label class="control-label required">{{ 'i18n.base.shared.email-form.form-fields.email-text' | translate }}</label>
      <ejs-richtexteditor #textHTML
                          id="textHTML"
                          formControlName="textHTML"
                          [insertImageSettings]='insertImageSettings'
                          [toolbarSettings]='tools'
                          (actionComplete)="onActionComplete($event)">
      </ejs-richtexteditor>
    </div>
  </div>
</form>
